import { render } from "./Join.vue?vue&type=template&id=5838dfe2&scoped=true&ts=true&lang=html"
import script from "./Join.vue?vue&type=script&lang=ts"
export * from "./Join.vue?vue&type=script&lang=ts"

import "./Join.vue?vue&type=style&index=0&id=5838dfe2&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5838dfe2"]])

export default __exports__